import useDBO from '../../hooks/useDBO';
import Loading from "../../Loading";
import Error from "../../components/Error";
import Staff from '../../components/Staff';
import HtClass from '../../components/HtClass';
import useCTX from '../../hooks/useCTX';
import HtTabs from '../../components/HtTabs';
import { useState } from 'react';
import MonthChoice from '../../components/MonthChoice';
import StoppedReasons from '../../components/StoppedReasons';
  
  export default function TeachersReport() {
    const [year, setYear] = useState(new Date().getFullYear())
    const [month,setMonth] = useState(new Date().getMonth())
    const {locations} = useCTX()

  const data = useDBO(`/teachers-report/${year}/${month+1}`)

  if (data.loading) return <Loading />
  if(data.error) return <Error />
  
  console.log(data.get)

    return (
      <div>
        <HtTabs
          labels={locations.map((l) => l.name)}
          components={locations.map((l) => (
            <DrawLocation
              data={data.filter((d) => d.locations.includes(l._id))}
            />
          ))}
          nextToTabs={
            <MonthChoice
              year={year}
              setYear={setYear}
              month={month}
              setMonth={setMonth}
            />
          }
        />
      </div>
    );
};
  
function DrawLocation({ data }) {

  let lessons = 0
  let attendances = 0

  for (const t of data) {
    for (const c of t.classes) {
      lessons += c.lessons.length;
      attendances += c.lessons.reduce((a,b)=> a + b.attended.length + b.late.length,0)
    }
   
  }

  return (
    <div>
      <h3>Lessons taught: {lessons},   Total attendances: {attendances}</h3>
       {data.map(teacher => <DrawTeacher teacher={teacher} key={teacher._id} />)}
    </div>
  );
}

function DrawTeacher({ teacher }) {
  
  const totalLessons = teacher.classes.reduce((a, b) => a + b.lessons.length, 0)
  const totalAttendances = teacher.classes.reduce(
    (a, b) =>
      a + b.lessons.reduce((c, d) => c + d.attended.length + d.late.length, 0),
    0
  );
  return (
    <div>
      <h3>
        <Staff id={teacher._id} />
      </h3>
      <table>
        <thead>
          <th>Name</th>
          <th>Lessons taught</th>
          <th>Students attended</th>
          <th>Students per lesson</th>
          <th>Stopped students</th>
          <th>Stopped reasons</th>
        </thead>
        {teacher.classes
          .sort((a, b) =>
            a.lessons.length > b.lessons.length
              ? -1
              : b.lessons.length > a.lessons.length
              ? 1
              : 0
          )
          .map((c) => (
            <tr>
              <td style={{ width: 200 }}>
                <HtClass
                  htClass={c.htClass}
                  link
                />{" "}
              </td>
              <td
                align="center"
                style={{ width: 200 }}
              >
                {c.lessons.length}
              </td>
              <td
                align="center"
                style={{ width: 200 }}
              >
                {c.lessons.reduce(
                  (a, b) => a + b.attended.length + b.late.length,
                  0
                )}
              </td>
              <td
                align="center"
                style={{ width: 200 }}
              >
                {Math.round(
                  c.lessons.reduce(
                    (a, b) => a + b.attended.length + b.late.length,
                    0
                  ) / c.lessons.length
                )}
              </td>
              <td
                align="center"
                style={{ width: 200 }}
              >
                {c.stopped}
              </td>
              <td style={{fontSize:11}}><StoppedReasons stoppedReasonsObject={c.stoppedReasons} /></td>
            </tr>
          ))}
        <tr style={{ fontWeight: "bold" }}>
          <td>Total</td>
          <td align="center">{totalLessons}</td>
          <td align="center">{totalAttendances}</td>
          <td align="center">{Math.round(totalAttendances / totalLessons)}</td>
          <td align="center">
            {teacher.classes.reduce((a, b) => a + b.stopped, 0)}
          </td>
        </tr>
      </table>
      <hr />
    </div>
  );
}